const TablePosition = require('../TablePosition')
const moveSelection = require('./moveSelection')

/**
 * Delete current column in a table
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} at
 * @return {Slate.Transform}
 */
function removeColumn (opts, transform, at) {
  const { state } = transform
  const { startBlock } = state

  const pos = TablePosition.create(state, startBlock, opts)
  const { table } = pos

  if (typeof at === 'undefined') {
    at = pos.getColumnIndex()
  }

  const rows = table.nodes

    // Remove the cell from every row
  if (pos.getWidth() > 1) {
    transform = moveSelection(opts, transform, pos.getColumnIndex() - 1, pos.getRowIndex())
    rows.forEach((row) => {
      const cell = row.nodes.get(at)
      transform.removeNodeByKey(cell.key)
    })
    transform = moveSelection(opts, transform, pos.getColumnIndex() + 1, pos.getRowIndex())
  } else {
    transform.removeNodeByKey(table.key)
  }

  return transform
}

module.exports = removeColumn



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/transforms/removeColumn.js